export default __webpack_public_path__ + "static/media/avatar.3dc97a29.svg";